'use strict';

var React = require('react');

var SvgIndentMinor = function SvgIndentMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 4.75a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5h-12.5a.75.75 0 0 1-.75-.75Zm7 3.5a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Zm0 3.5a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Zm-7 3.5a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5h-12.5a.75.75 0 0 1-.75-.75Zm.96-2.35c-.41.262-.96-.02-.96-.493v-4.814c0-.473.55-.755.96-.493l3.765 2.408a.579.579 0 0 1 0 .985l-3.765 2.407Z"
  }));
};
SvgIndentMinor.displayName = "IndentMinor";

exports.SvgIndentMinor = SvgIndentMinor;
